var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCopyRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h20v20H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.833 5V2.5c0-.46.373-.833.834-.833h10c.46 0 .833.373.833.833v11.667c0 .46-.373.833-.833.833h-2.5v2.5c0 .46-.375.833-.84.833H3.34A.834.834 0 0 1 2.5 17.5l.002-11.667c0-.46.376-.833.84-.833h2.491zM4.17 6.667l-.002 10H12.5v-10H4.17zM7.5 5h6.667v8.333h1.666v-10H7.5V5z",
    fill: "#DE3530",
    fillRule: "nonzero"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyRed);
export default __webpack_public_path__ + "static/media/copy_red.cb90eb93156463da3512961b86d797b8.svg";
export { ForwardRef as ReactComponent };